import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDGRLEZQITSkeg6V3SxmQVqSvpW-Ex7jc0",
  authDomain: "blog-meryl.firebaseapp.com",
  databaseURL: "https://blog-meryl.firebaseio.com",
  projectId: "blog-meryl",
  storageBucket: "blog-meryl.appspot.com",
  messagingSenderId: "444269757134",
  appId: "1:444269757134:web:24df85f6b71790851b869f"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Configurer la persistance de l'authentification
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Erreur de configuration de la persistance:", error);
});

const db = getDatabase(app);
const storage = getStorage(app);

export { auth, db, storage };